if (typeof CurrencyExchanger !== 'function') {
	class CurrencyExchanger extends HTMLElement {

	constructor() {
		super();

		this.selectors = {
			toggleDropdownCurrencies: ".currency-exchange-rate__button",
			dropdownCurrenciesContainer: ".currency-exchange-rate__dropdown",
			currencySelectorItem: ".currency-exchange-rate__dropdown > li",
			currencySelectorItemSelected:
				".currency-exchange-rate__selected-currency",
			moneySpan: "span.money",
		};

		this.elements = {
			toggleDropdownCurrencies: this.querySelector(
				this.selectors.toggleDropdownCurrencies
			),
			dropdownCurrenciesContainer: this.querySelector(
				this.selectors.dropdownCurrenciesContainer
			),
			currencySelectorItem: this.querySelectorAll(
				this.selectors.currencySelectorItem
			),
			currencySelectorItemSelected: this.querySelector(
				this.selectors.currencySelectorItemSelected
			),
		};

		this.classes = {
			dropdownVisible: "currency-exchange-rate__dropdown--open",
		};

		this.localCurrencyData = {};
		this.selectedCurrency = "AED";

		this.init();
	}

	async init() {
		await this.checkCurrencyData();

		this.localCurrencyData = JSON.parse(
			localStorage.getItem("currencyExchangeData")
		);

		this.localCurrencyData.selectedCurrency
			? this.changeSelectedCurrency(
					this.localCurrencyData.selectedCurrency
			  )
			: this.changeSelectedCurrency("AED");

		this.addListeners();

		if (this.selectedCurrency !== "AED") {
			this.convertCurrency(this.selectedCurrency);
		}
	}

	addListeners() {
		this.elements.toggleDropdownCurrencies.addEventListener("click", () => {
			this.toggleCurrencyDropdown();
		});

		this.elements.currencySelectorItem.forEach((button) =>
			button.addEventListener("click", () => {
				this.changeSelectedCurrency(button.textContent);
				this.toggleCurrencyDropdown();
				this.convertCurrency(button.textContent);
			})
		);

		// Move the event listeners that depend on the selected currency inside the changeSelectedCurrency method.
		document.addEventListener("theme:variant:change", (event) => {
			if (event.detail.type === "single") {
				const element = event.detail.element.querySelector(
					this.selectors.moneySpan
				);

				this.convertPriceElement(
					element,
					this.selectedCurrency,
					this.selectedCurrency === "AED"
						? 1
						: this.localCurrencyData.rates[this.selectedCurrency]
				);
			} else {
				this.convertCurrency(this.selectedCurrency);
			}
		});

		// We won't attach cart listeners here as they depend on the currency
		// We'll attach them inside the changeSelectedCurrency method to make sure the correct currency is used.
	}

	// Updated changeSelectedCurrency method to reattach event listeners with the new currency.
	changeSelectedCurrency(currency) {
		this.selectedCurrency = currency;
		this.localCurrencyData.selectedCurrency = currency;
		this.elements.currencySelectorItemSelected.textContent =
			this.selectedCurrency;

		localStorage.setItem(
			"currencyExchangeData",
			JSON.stringify(this.localCurrencyData)
		);

		// Update event listeners that depend on selectedCurrency to use the current currency.
		this.updateCurrencyListeners();
	}

	// This method will be called every time the currency changes to attach updated event listeners.
	updateCurrencyListeners() {
		document.removeEventListener("theme:cart-drawer:open", this.handleCartDrawerOpen);
		document.removeEventListener("theme:cart:change", this.handleCartChange);
		document.removeEventListener("theme:cart:update", this.handleCartUpdate);
		document.removeEventListener("quick-add:modal-open", this.handleQuickAdd);
		document.removeEventListener("predictive-search:results-rendered", this.handlePredictiveSearch);
		document.removeEventListener("collection:filters:updated", this.handleFilterUpdate);
		document.removeEventListener("wishlist-page-mounted", this.handleWishlistPageMounted);
		document.removeEventListener("recently-viewed-mounted", this.handleRecentlyViewedMounted);

		// Define the event handlers as instance properties to allow removal later.
		this.handleCartDrawerOpen = (event) => {
			this.convertCurrency(this.selectedCurrency, event.detail.element);
		};
		this.handleCartChange = (event) => {
			this.convertCurrency(this.selectedCurrency, event.detail.element);
		};
		this.handleCartUpdate = (event) => {
			this.convertCurrency(this.selectedCurrency, event.detail.element);
		};
		this.handleQuickAdd = (event) => {
			this.convertCurrency(this.selectedCurrency, event.detail.element);
		};
		this.handlePredictiveSearch = (event) => {
			this.convertCurrency(this.selectedCurrency, event.detail.element);
		}
		this.handleFilterUpdate = (event) => {
			this.convertCurrency(this.selectedCurrency, event.detail.element);
		}
		this.handleWishlistPageMounted = (event) => {
			this.convertCurrency(this.selectedCurrency, event.detail.element);
		};
		this.handleRecentlyViewedMounted = (event) => {
			this.convertCurrency(this.selectedCurrency, event.detail.element.container);
		};

		// Attach event listeners again with the updated selectedCurrency.
		document.addEventListener("theme:cart-drawer:open", this.handleCartDrawerOpen);
		document.addEventListener("theme:cart:change", this.handleCartChange);
		document.addEventListener("theme:cart:update", this.handleCartUpdate);
		document.addEventListener("quick-add:modal-open", this.handleQuickAdd);
		document.addEventListener("predictive-search:results-rendered", this.handlePredictiveSearch);
		document.addEventListener("collection:filters:updated", this.handleFilterUpdate);
		document.addEventListener("wishlist-page-mounted", this.handleWishlistPageMounted);
		document.addEventListener("recently-viewed-mounted", this.handleRecentlyViewedMounted);
	}

	hasLocalDataExpired(localTimestamp) {
		const now = Date.now() / 1000;
		const allowedDifference = 12 * 60 * 60 * 1000; // 12 h

		return now - localTimestamp > allowedDifference;
	}

	async getDataFromMongo() {
		const currencyAPI =
			"https://sleepy-atoll-73441.herokuapp.com/https://data.mongodb-api.com/app/data-arjwr/endpoint/data/beta";

		const header = {
			"Content-Type": "application/json",
			"Access-Control-Request-Headers": "*",
			"api-key":
				"EPFMERggoTLFoGPD3UvdLmsWiRBdahgRtYfWseAuZGpnCqBL0ARke8AfNCixWrAk",
		};

		const initBodyData = {
			dataSource: "Cluster0",
			database: "fyne-jewellery",
			collection: "exchange-rates",
		};

		try {
			const response = await fetch(`${currencyAPI}/action/findOne`, {
				method: "POST",
				headers: header,
				body: JSON.stringify({
					...initBodyData,
				}),
			});

			const jsonData = await response.json();

			localStorage.setItem(
				"currencyExchangeData",
				JSON.stringify(jsonData.document)
			);
		} catch (error) {
			console.error(error);
		}
	}

	async checkCurrencyData() {
		const localCurrencyData = JSON.parse(
			localStorage.getItem("currencyExchangeData")
		);

		if (
			localCurrencyData === null || // Empty Local Storage
			this.hasLocalDataExpired(localCurrencyData.timestamp) // Data has expired
		) {
			await this.getDataFromMongo();
		}
	}

	convertCurrency(currency, wrapper) {
		const exchangeRate =
			currency === "AED" ? 1 : this.localCurrencyData.rates[currency];
		wrapper = wrapper || document;

		wrapper
			.querySelectorAll(this.selectors.moneySpan)
			.forEach((element) => {
				this.convertPriceElement(element, currency, exchangeRate);
			});
	}

	convertPriceElement(element, currency, exchangeRate) {
		const parentCartElement = element.closest('.cart__total__price');
	
		if (parentCartElement && parentCartElement.dataset.cartTotal) {
			const cartTotalPrice = +parentCartElement.dataset.cartTotal;
			const newPrice = Math.ceil(exchangeRate * (cartTotalPrice / 100));
	
			element.textContent = `${this.numberWithCommas(newPrice)} ${currency}`;
		} else {
			const firstRun = typeof element.dataset.initialPrice === "undefined";
			const currentPrice = firstRun
				? +element.textContent.split(" ")[0].replace(",", "")
				: element.dataset.initialPrice;
			const newPrice = Math.ceil(exchangeRate * currentPrice);
	
			if (firstRun) {
				element.dataset.initialPrice = currentPrice;
			}
	
			element.textContent = `${this.numberWithCommas(newPrice)} ${currency}`;
		}
	}

		numberWithCommas(number) {
		var parts = number.toString().split(".");
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

			if (parts[parts.length - 1] == "00" || parts[parts.length - 1] == "0") {
				return parts[0];
			} else {
				return parts.join(".");
			}
		}

		toggleCurrencyDropdown() {
			this.elements.dropdownCurrenciesContainer.classList.toggle(
				this.classes.dropdownVisible
			);
		}
	}

	if (!customElements.get('currency-exchange-rate')) {
		customElements.define('currency-exchange-rate', CurrencyExchanger);
	}
}